import { nullable, number, object, optional, string } from "superstruct";

//This schema is used in v3 api endpoints
export const RewardsProductSchema = object({
    id: number(),
    title: optional(string()),
    image: optional(nullable(string())),
    handle: optional(string()),
});
